<template>
  <div class="uploadfile">




    <!-- Element Plus 上传组件 -->
    <el-upload ref="uploadRef" class="upload-demo" drag :action="uploadUrl" :headers="uploadHeaders" :data="uploadData"
      :before-upload="beforeUpload" :on-success="handleUploadSuccess" :on-error="handleUploadError"
      :on-progress="handleUploadProgress" v-model:file-list="fileList" :auto-upload="false" :accept="'.xlsx,.xls'"
      :limit="limit" :multiple="true" :on-exceed="handleExceed" :on-change="handleFileChange">
      <template #trigger>
        <div class="upload-trigger">
          <el-icon class="el-icon--upload"><upload-filled /></el-icon>
          <div class="el-upload__text">
            将文件拖到此处,或<em>点击选择</em>
          </div>
        </div>
      </template>
      <template #tip>
        <div class="el-upload__tip">
          支持批量选择多个文件(最多{{ limit }}个)
        </div>
      </template>
    </el-upload>

    <!-- 操作按钮 -->
    <div class="upload-actions">

      <el-button v-if="fileList.length > 0" @click="clearFiles">清空文件</el-button>
      <el-button v-if="ricelist.length > 0" @click="printDataPreview" type="success" :loading="uploadingInventory">
        {{ uploadingInventory ? '打印中...' : '打印文件' }}
      </el-button>

      <!-- <el-button v-if="fileList.length > 1" @click="batchProcessFiles" type="primary" :loading="batchProcessing">
                {{ batchProcessing ? '批量处理中...' : '批量处理所有文件' }}
            </el-button> -->

    </div>

    <!-- 读取结果 -->
    <div v-if="uploadResult" class="upload-result">
      <el-alert v-if="uploadResult.success" title="文件信息读取成功" type="success" :closable="false" show-icon>
        <template #default>

          <p v-for="(item, index) in fileList" :key="index">{{ index + 1 }}. {{ item.name || item.fileName || '未知文件' }}( 读取了
            {{ (ricelist[index] && ricelist[index].length) || 0 }} 条数据)</p>

          <p>{{ uploadResult.message || '文件信息已读取,可以查看数据预览' }}</p>
          <p>请查看控制台了解详细信息</p>
        </template>
      </el-alert>

      <el-alert v-else title="文件读取失败" type="error" :closable="false" show-icon>
        <template #default>
          {{ uploadResult.message }}
        </template>
      </el-alert>
    </div>

    <!-- 数据预览 -->
    <!-- <div v-if="rice.length > 0" class="data-preview">
            <el-card :header="filetitle">
                <el-table :data="rice" style="width: 100%" max-height="300">
                    <el-table-column prop="id" label="编号" width="80" />
                    <el-table-column prop="nametd" label="废旧物资名称" width="150" />
                    <el-table-column prop="typenumber" label="规格型号" width="120" />
                    <el-table-column prop="pronumber" label="批次号" width="100" />
                    <el-table-column prop="unit" label="单位" width="80" />
                    <el-table-column prop="heavey" label="数量" width="80" />
                    <el-table-column prop="address" label="废旧物资存放地点" />
                    <el-table-column prop="details" label="备注" />
                    <el-table-column prop="detailsunit" label="备注(实际计量单位)" />
                
                </el-table>
            </el-card>
        </div> -->


  </div>
</template>

<script>
import { ElMessage } from 'element-plus';

import request from '@/api/api';
import { UploadFilled } from '@element-plus/icons-vue';

export default {
  name: 'uploadxls',
  components: {
    UploadFilled
  },
  data() {
    return {
      tenderid: '',
      limit: 5,
      fileList: [],
      uploading: false,
      uploadResult: null,
      rice: [],
      findtage123: [],
      findtage123copy: [],
      findtage123all: [],
      filetitle: '',
      filetitlelist: [],
      ricelist: [],

      uploadingInventory: false,
      batchProcessing: false,
      tenderbatch: '',
      isOnline: navigator.onLine,
      isMobile: /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent),
      isMiniProgram: /MicroMessenger/i.test(navigator.userAgent) && /miniProgram/i.test(navigator.userAgent),
      // 上传配置
      uploadUrl: 'https://abc.smbmhs.cn/TenderEntity/readerxlsx2',
      uploadHeaders: {
        'Content-Type': 'multipart/form-data'
      },
      uploadData: {
        type: 'file'
      },

    }
  },
  mounted() {
    // 监听网络状态变化
    window.addEventListener('online', this.handleOnline)
    window.addEventListener('offline', this.handleOffline)
  },
  beforeUnmount() {
    // 清理事件监听器
    window.removeEventListener('online', this.handleOnline)
    window.removeEventListener('offline', this.handleOffline)
  },
  methods: {
    // 网络状态处理
    handleOnline() {
      this.isOnline = true
      ElMessage.success('网络连接已恢复')
    },
    handleOffline() {
      this.isOnline = false
      ElMessage.warning('网络连接已断开,请检查网络设置')
    },

    // 检查网络连接
    checkNetworkConnection() {
      if (!this.isOnline) {
        ElMessage.error('网络连接已断开,请检查网络设置后重试')
        return false
      }
      return true
    },

    // 文件状态改变时的处理(文件选择后立即触发)
    async handleFileChange(file, fileList) {
      console.log('文件状态改变:', file, fileList)

      // 只有当文件状态为 'ready' 时才处理(新选择的文件)
      if (file.status === 'ready') {
        console.log('检测到新文件选择,开始读取文件信息')
        await this.readFileInfo(file.raw)
      }
    },

    // 批量处理所有文件
    async batchProcessFiles() {
      this.batchProcessing = true
      try {
        if (this.fileList.length === 0) {
          ElMessage.warning('请先选择文件')
          return
        }

        console.log('🚀 开始批量处理文件:', this.fileList.length, '个文件')

        for (let i = 0; i < this.fileList.length; i++) {
          const file = this.fileList[i]
          console.log(`📁 处理第 ${i + 1}/${this.fileList.length} 个文件:`, file.name)

          try {
            await this.readFileInfo(file.raw)
            console.log(`✅ 第 ${i + 1} 个文件处理完成`)

            // 等待一小段时间再处理下一个文件
            if (i < this.fileList.length - 1) {
              await new Promise(resolve => setTimeout(resolve, 1000))
            }
          } catch (error) {
            console.error(`❌ 第 ${i + 1} 个文件处理失败:`, error)
            ElMessage.error(`文件 ${file.name} 处理失败`)
          }
        }

        ElMessage.success(`批量处理完成! 共处理 ${this.fileList.length} 个文件`)
      } finally {
        this.batchProcessing = false
      }
    },

    // 文件验证(手机端兼容版)
    beforeUpload(file) {
      console.log('📱 文件验证 - 设备信息:', {
        userAgent: navigator.userAgent,
        isMobile: /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent),
        fileType: file.type,
        fileName: file.name,
        fileSize: file.size
      })

      // 手机端文件类型检测可能不准确,主要依赖文件扩展名
      const allowedExtensions = ['.xlsx', '.xls', '.csv']
      const fileName = file.name.toLowerCase()
      const hasValidExtension = allowedExtensions.some(ext => fileName.endsWith(ext))

      // 如果文件类型为空或未知,但扩展名正确,也允许通过
      const isAllowedType = file.type && (
        file.type.includes('sheet') ||
        file.type.includes('excel') ||
        file.type.includes('csv') ||
        file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ||
        file.type === 'application/vnd.ms-excel' ||
        file.type === 'text/csv'
      ) || hasValidExtension

      if (!isAllowedType) {
        ElMessage.error('只能选择 xlsx/xls/csv 格式的文件!')
        return false
      }

      // 手机端文件大小限制更宽松
      const isLt20M = file.size / 1024 / 1024 < 20
      if (!isLt20M) {
        ElMessage.error('文件大小不能超过 20MB!')
        return false
      }

      console.log('✅ 文件验证通过:', {
        name: file.name,
        type: file.type,
        size: file.size
      })

      return true // 允许文件选择
    },

    // 读取文件信息的方法(手机端兼容版)
    async readFileInfo(file) {
      // 检查网络连接
      if (!this.checkNetworkConnection()) {
        return
      }

      // 文件验证已在 beforeUpload 中完成,这里直接读取
      try {
        console.log('🚀 开始读取文件:', file.name)
        console.log('📱 设备信息:', {
          userAgent: navigator.userAgent,
          isMobile: /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent),
          platform: navigator.platform
        })
        console.log('📁 文件信息:', {
          name: file.name,
          size: file.size,
          type: file.type,
          lastModified: file.lastModified
        })

        // 检查文件是否有效
        if (!file || !file.name) {
          throw new Error('文件无效或文件名为空')
        }

        // 根据后端 @RequestBody MultipartFile file 调整请求方式
        const formData = new FormData()

        // 手机端兼容性处理:确保文件对象正确
        if (file.raw) {
          formData.append('file', file.raw, file.name)
        } else {
          formData.append('file', file, file.name)
        }

        console.log('🌐 发送请求到:', this.uploadUrl)
        console.log('📦 FormData 内容:', {
          file: file.name,
          hasRaw: !!file.raw,
          formDataKeys: Array.from(formData.keys())
        })
        console.log('🔧 后端接口信息:', {
          url: 'https://abc.smbmhs.cn/TenderEntity/readerxlsx2',
          method: 'POST',
          parameter: '@RequestBody MultipartFile file',
          note: '后端只接收文件参数,不需要额外的 type 参数'
        })

        // 使用完整的 URL,增加超时时间
        const response = await request('/excel/read', 'post', formData, {
          timeout: 60000 // 60秒超时
        })
        let stinglist = ["废铁", "外壳废铁", "螺丝废铁", "铜包", "高压火烧铜", "低压火烧铜", "杂质", "低压漆包铜", "高压漆包铜", "漆包铜", "镀白紫铜", "镀白黄铜", "镀白铜", "镀银紫铜", "镀银黄铜", "紫铜", "黄铜", "光亮铜", "光亮紫铜", "焊点铜", "焊点紫铜", "焊点镀白紫铜", "杂铜", "零铜", "氧化紫铜", "铜排", "铜线", "生铝", "铝", "铝壳", "铝箔", "小货", "陶瓷", "陶瓷＋废铁", "不锈钢", "304", "矽钢片线包", "矽钢片铜包", "矽钢片漆包铜", "矽钢片", "矽钢片厚度（mm）", "矽钢片长度", "铝棒", "纯铝棒", "镀银铜包铝", "铜铝鼻子", "塑料盒非晶体", "非晶体铁架", "下炉料", "细线", "线材", "杂货", "油/垃圾", "非晶架（圆形铝壳）", "火烧紫铜片", "火烧紫铜丝（粗）", "非晶架", "避雷器", "绝缘子", "散热片", "电机", "温度控制器", "金属杂件", "电子杂件", "接触器", "断路器", "锌"]
        let dataList = response.data.data

        dataList.forEach(v => {
          v.bidId = 1996
          v.model = v['型号']
          v.brand = v['品牌']
          v.manufactDate = v['日期'] 
          v.weight = v['铭牌总重']  ||0;

          v.brandType = 1;
          //    铭牌器身重
          v.weightMpqs = v['铭牌器身重'] ||0;
          //    铭牌油重
          v.weightMpy = v['油重'] ||0;
          //    含油总重
          v.weightHy = v['含油总重'] ||0;
          //    无油总重
          v.weightWy = v['无油净重'] ||0;
          //    油重
          v.weighty = v['油重'] ||0;
          v.remark = v['类型']
          v.storeList = []
          for (let i = 0; i < stinglist.length; i++) {

            if (v[`${stinglist[i]}`] != null && v[`${stinglist[i]}`] != undefined 
            && stinglist[i]!='矽钢片厚度（mm）' && stinglist[i]!='矽钢片长度'
             && stinglist[i]!='废铁1' && stinglist[i]!='外壳废铁'
             && stinglist[i]!='螺丝废铁' && stinglist[i]!='火烧紫铜1'
             && stinglist[i]!='火烧紫铜2' 

             
          ) {
              v.storeList.push({
                bidId: 1996, productElementId: 0, sourceId: 0, status: 3,
                source: 1, quantity: v[`${stinglist[i]}`], remark: stinglist[i]
              })
            }
          }
        })


        console.log('✅ 文件读取成功,API 返回数据AAAAAAA', dataList)
        // /productStore/importfromexcel
        request('/productStore/importfromexcel', 'post', dataList, {
          timeout: 60000 // 60秒超时
        }).then(res => {
          console.log('✅ 数据导入成功', res)
        }).catch(err => {
          console.error('❌ 数据导入失败', err)
        })
     

        // 处理读取到的数据,传入文件名(去掉扩展名)
        const fileName = file.name.replace(/\.[^/.]+$/, '')
        this.processUploadData(response.data, fileName)

        ElMessage.success('文件信息读取成功!')

        // 显示读取结果
        this.uploadResult = {
          success: true,
          filetitle: this.filetitle,
          dataList: this.rice,
          message: '文件信息已读取,可以查看数据预览'
        }

      } catch (error) {
        console.error('❌ 文件读取失败:', error)
        console.error('🔍 完整错误对象:', error)
        console.error('📱 手机端错误详情:', {
          userAgent: navigator.userAgent,
          isMobile: /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent),
          online: navigator.onLine,
          message: error.message,
          code: error.code,
          status: error.response?.status,
          statusText: error.response?.statusText,
          data: error.response?.data,
          headers: error.response?.headers,
          config: {
            url: error.config?.url,
            method: error.config?.method,
            baseURL: error.config?.baseURL,
            headers: error.config?.headers,
            timeout: error.config?.timeout
          }
        })

        let errorMessage = '文件读取失败'
        let isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)

        if (error.response) {
          errorMessage = `服务器错误: ${error.response.status} ${error.response.statusText}`
          if (error.response.data) {
            console.log('服务器返回的错误数据:', error.response.data)
            errorMessage += ` - ${JSON.stringify(error.response.data)}`
          }
        } else if (error.request) {
          if (isMobile) {
            errorMessage = '网络请求失败,请检查手机网络连接或尝试切换WiFi/移动数据'
          } else {
            errorMessage = '网络请求失败,请检查网络连接'
          }
        } else if (error.message.includes('timeout')) {
          errorMessage = '请求超时,请检查网络状况或文件大小'
        } else if (error.message.includes('Network Error')) {
          errorMessage = '网络错误,请检查网络连接'
        } else if (error.message.includes('CORS')) {
          errorMessage = '跨域请求被阻止,请联系管理员'
        } else {
          errorMessage = error.message || '未知错误'
        }

        // 手机端特殊提示
        if (isMobile) {
          errorMessage += '\n\n💡 手机端提示:\n1. 请确保网络连接正常\n2. 尝试切换WiFi或移动数据\n3. 检查文件格式是否正确\n4. 文件大小不要超过20MB'
        }

        ElMessage.error(errorMessage)

        // 设置失败结果
        this.uploadResult = {
          success: false,
          message: errorMessage
        }
      }
    },

    // 文件数量超出限制
    handleExceed(files, fileList) {
      // ElMessage.warning(`只能选择 1 个文件,当前选择了 ${files.length} 个文件`)

      ElMessage.warning(`最多只能选择 ${this.limit} 个文件,当前选择了 ${files.length} 个文件,共选择了 ${files.length + fileList.length} 个文件`)
    },

    // 上传进度
    handleUploadProgress(event, file, fileList) {
      console.log('上传进度:', event.percent)
    },

    // 上传成功
    handleUploadSuccess(response, file, fileList) {
      this.uploading = false
      console.log('上传成功:', response)

      try {
        // 获取文件名(去掉扩展名)
        const fileName = file.name ? file.name.replace(/\.[^/.]+$/, '') : null
        this.processUploadData(response, fileName)

        this.uploadResult = {
          success: true,
          filetitle: this.filetitle,
          dataList: this.rice
        }

        // ElMessage.success('文件上传成功!')
      } catch (error) {
        console.error('数据处理失败:', error)
        this.uploadResult = {
          success: false,
          message: '数据处理失败'
        }
        ElMessage.error('数据处理失败')
      }
    },

    // 上传失败
    handleUploadError(error, file, fileList) {
      this.uploading = false
      console.error('上传失败:', error)

      this.uploadResult = {
        success: false,
        message: error.message || '上传失败,请重试'
      }

      ElMessage.error('文件上传失败!')
    },

    // 处理上传返回的数据
    async processUploadData(data, fileName) {
      try {
        console.log('开始处理数据:', data)

        // 根据返回结构 JSON.parse(data.data).data 来获取实际数据
        let actualData
        if (typeof data === 'string') {
          // 如果 data 是字符串,需要先解析
          const parsedData = JSON.parse(data)
          actualData = parsedData.data
          console.log('解析后的数据:', parsedData)
        } else if (data && data.data) {
          // 如果 data 是对象且有 data 属性
          actualData = data.data
          console.log('直接获取 data 属性:', actualData)
        } else {
          // 如果 data 直接就是数组
          actualData = data
          console.log('data 直接是数组:', actualData)
        }

        console.log('实际数据列表:', actualData)

        if (!actualData || !Array.isArray(actualData)) {
          throw new Error('数据格式不正确,期望数组格式')
        }

        const dataList1 = actualData
        // 使用文件名作为 filetitle,如果没有传入文件名则使用默认值
        this.filetitle = fileName || `文件_${new Date().getTime()}`

        this.filetitlelist.push(this.filetitle)
        console.log(dataList1, 'dataList1', this.filetitle, 'filetitle')



        let dataList = []
        dataList1.forEach(m => {
          // m['编号'] =parseInt(m['编号']) || parseInt(m['序号'])
          // 获取编号或序号的值
          const numberValue = m['编号'] || m['序号']
          const heavyValue = m['数量'] || m['重量']

          // 判断 parseInt 后是否是有效数字(整数)
          const isnumber = numberValue !== undefined &&
            numberValue !== null &&
            numberValue !== '' &&
            !isNaN(parseInt(numberValue))

          // 判断 parseFloat 后是否是有效数字(可以是整数或浮点数)
          const parsedHeavy = parseFloat(heavyValue)
          const isheavy = heavyValue !== undefined &&
            heavyValue !== null &&
            heavyValue !== '' &&
            !isNaN(parsedHeavy) &&
            isFinite(parsedHeavy) // 确保是有限数字,排除 Infinity
          // 如果编号/序号是有效数字且批次号不为空,则添加到数据列表
          if (isnumber && isheavy) {
            dataList.push(m)
          }
        })



        this.rice = dataList
        this.ricelist.push(this.rice)



        console.log('rice', this.rice)




      } catch (error) {
        console.error('数据处理失败:', error)
        console.error('原始数据:', data)
        throw error
      }
    },


    async uploadprintfile() {
      this.uploadingInventory = true
      try {
        console.log('🖨️ 开始打印数据预览内容')

        // 检查是否有数据可以打印
        if (!this.ricelist || this.ricelist.length === 0) {
          ElMessage.warning('没有数据可以打印,请先上传文件')
          return
        }


        ElMessage.success('打印任务已启动')
      }
      catch (error) {
        console.error('❌ 打印失败:', error)
        ElMessage.error('打印失败,请重试')
      } finally {
        this.uploadingInventory = false
      }
    },

    // 打印数据预览内容
    printDataPreview() {
      try {
        console.log('📄 准备打印数据:', this.ricelist)
        console.log('📊 文件数量:', this.ricelist.length)
        console.log('📋 文件标题列表:', this.filetitlelist)

        // 检查是否有数据可以打印
        if (!this.ricelist || this.ricelist.length === 0) {
          ElMessage.warning('没有数据可以打印,请先上传文件')
          return
        }

        // 创建打印窗口
        const printWindow = window.open('', '_blank', 'width=1200,height=800')

        if (!printWindow) {
          ElMessage.error('无法打开打印窗口,请检查浏览器设置')
          return
        }

        // 构建打印内容HTML
        const printContent = this.generatePrintHTML()

        // 写入打印内容
        printWindow.document.write(printContent)
        printWindow.document.close()

        // 等待内容加载完成后打印
        printWindow.onload = () => {
          setTimeout(() => {
            printWindow.print()
            printWindow.close()
          }, 500)
        }

      } catch (error) {
        console.error('❌ 打印内容生成失败:', error)
        ElMessage.error('打印内容生成失败: ' + error.message)
      }
    },

    // 生成打印HTML内容
    generatePrintHTML() {
      // ricelist filetitlelist
      // console.log(this.ricelist, 'ricelist in generatePrintHTML');
      // console.log(this.filetitlelist, 'filetitlelist in generatePrintHTML');

      const currentDate = new Date().toLocaleString('zh-CN')
      const fileCount = this.ricelist.length

      // 获取第一个文件的标题作为页面标题
      const pageTitle = this.filetitlelist[0] || '打印文件'

      // 构建所有文件的表格HTML
      let allTablesHTML = ''

      for (let i = 0; i < fileCount; i++) {
        const fileTitle = this.filetitlelist[i] || `文件${i + 1}`
        const fileData = this.ricelist[i] || []

        // 如果没有数据,跳过
        if (fileData.length === 0) continue

        // 从第二条数据获取所有字段(第一条可能是标题行)
        const dataItem = fileData.length > 1 ? fileData[1] : fileData[0]
        const fields = Object.keys(dataItem)
        console.log(fields, 'fields for file', i + 1);

        // 定义不同字段的宽度规则
        const getColumnWidth = (field) => {
          const fieldLower = field.toLowerCase()
          // 编号、序号类


          if (fieldLower == '编号' || fieldLower.includes('序号') || field === 'id') {
            return 'width: 3%;'
          }

          // 数量类
          if (fieldLower.includes('数量')) {
            return 'width: 5%;'
          }
          // 时间、日期类
          if (fieldLower.includes('时间') || fieldLower.includes('日期')) {
            return 'width: 8%;'
          }
          // 批次号类
          if (fieldLower.includes('批次') || fieldLower.includes('原资产编码') || fieldLower.includes('报废审批表编号')) {
            return 'width: 8%;'
          }
          // 规格型号、描述类
          if (fieldLower.includes('规格') || fieldLower.includes('型号') || fieldLower.includes('描述')) {
            return 'width: 10%;'
          }
          // 名称类
          if (fieldLower.includes('名称') || fieldLower.includes('公司') ||
            fieldLower.includes('单位名称')) {
            return 'width: 10%;'
          }
          // 地点、地址类
          if (fieldLower.includes('地点') || fieldLower.includes('地址') || fieldLower.includes('存放')) {
            return 'width: 10%;'
          }
          // 备注类
          if (fieldLower.includes('备注')) {
            return 'width: 5%;'
          }
          if (fieldLower.includes('物料编号')) {
            return 'width: 8%;'
          }
          if (fieldLower.includes('废旧物资') || fieldLower.includes('物资名称') || fieldLower.includes('资产名称')) {
            return 'width: 8%;'
          }

          // 默认宽度
          return 'width: auto;'
        }

        let tableHeaders = ''
        fields.forEach(field => {
          const widthStyle = getColumnWidth(field)
          tableHeaders += `<th style="${widthStyle}">${field}</th>`
        })

        // 动态构建表格行
        let tableRows = ''
        fileData.forEach((item, index) => {
          let rowCells = ''
          fields.forEach(field => {
            const value = item[field]
            const fieldLower = field.toLowerCase()

            // 对于 id 字段,如果为空则使用索引
            if (field === 'id' && (value === undefined || value === null || value === '')) {
              rowCells += `<td>${index + 1}</td>`
            }
            // 对于序号或编号字段,转换为整数显示
            else if (fieldLower === '序号' || fieldLower === '编号' || field === '序号' || field === '编号') {
              if (value !== undefined && value !== null && value !== '') {
                const intValue = parseInt(value)
                rowCells += `<td>${intValue}</td>`
              } else {
                rowCells += `<td></td>`
              }
            }
            // 其他字段,空值显示为空字符串
            else {
              rowCells += `<td>${value !== undefined && value !== null ? value : ''}</td>`
            }
          })
          tableRows += `<tr>${rowCells}</tr>`
        })

        // 构建单个文件的完整表格
        allTablesHTML += `
                    <div class="file-section">
                        <div class="print-header">
                            <div class="print-title">${fileTitle}</div>
                        </div>
                        
                        <table class="print-table">
                            <thead>
                                <tr>${tableHeaders}</tr>
                            </thead>
                            <tbody>
                                ${tableRows}
                            </tbody>
                        </table>
                        
                      
                    </div>
                `
      }


      return `
                <!DOCTYPE html>
                <html lang="zh-CN">
                <head>
                    <meta charset="UTF-8">
                    <meta name="viewport" content="width=device-width, initial-scale=1.0">
                    <title>${pageTitle}</title>
                    <style>
                        body {
                            font-family: 'Microsoft YaHei', Arial, sans-serif;
                            margin: 2px;
                            color: #333;
                            line-height: 1.2;
                            font-size: 8px;
                        }
                        .print-header {
                            text-align: center;
                            margin-bottom: 5px;
                            border-bottom: 2px solid #333;
                            padding-bottom: 5px;
                        }
                        .print-title {
                            font-size: 16px;
                            font-weight: bold;
                            color: #333;
                            margin-bottom: 5px;
                        }
                        .print-info {
                            font-size: 8px;
                            color: #666;
                            margin-bottom: 5px;
                        }
                        .print-table {
                            width: 100%;
                            border-collapse: collapse;
                            margin-top: 5px;
                            box-shadow: 0 2px 8px rgba(0,0,0,0.1);
                            table-layout: fixed;
                        }
                        .print-table th {
                            background: #f5f5f5;
                            color: #333;
                            padding: 2px 3px;
                            text-align: center;
                            font-weight: bold;
                            border: 1px solid #ddd;
                            word-wrap: break-word;
                            word-break: break-all;
                            overflow: hidden;
                            font-size: 8px;
                        }
                        .print-table td {
                            padding: 2px 3px;
                            border: 1px solid #ddd;
                            text-align: center;
                            vertical-align: middle;
                            word-wrap: break-word;
                            word-break: break-all;
                            overflow: hidden;
                            font-size: 8px;
                            line-height: 1.2;
                        }
                        .print-table tr:nth-child(even) {
                            background-color: #f8f9fa;
                        }
                        .print-footer {
                            margin-top: 5px;
                            text-align: center;
                            font-size:8px;
                            color: #666;
                            border-top: 1px solid #eee;
                            padding-top: 5px;
                        }
                        .data-summary {
                            background: #f5f5f5;
                            padding: 5px;
                            border-radius: 8px;
                            margin-bottom: 5px;
                            border-left: 4px solid #333;
                        }
                        .file-section {
                            page-break-after: always;
                            margin-bottom: 5px;
                        }
                        .file-section:last-child {
                            page-break-after: avoid;
                        }
                        .file-footer {
                            margin-top: 10px;
                            text-align: center;
                            font-size: 12px;
                            color: #666;
                            border-top: 1px solid #eee;
                            padding-top: 10px;
                        }
                        .summary-item {
                            display: inline-block;
                            margin-right: 5px;
                            font-weight: bold;
                        }
                        @media print {
                            body { margin: 0; }
                            .print-header { page-break-after: avoid; }
                            
                            /* 表格分页控制 - 允许表格跨页 */
                            .print-table { 
                                page-break-inside: auto;
                                border-collapse: collapse;
                            }
                            
                            /* 表头只在第一页显示,后续页面不重复 */
                            .print-table thead { 
                                display: table-header-group;
                            }
                            
                            .print-table thead th { 
                                page-break-inside: avoid;
                                page-break-after: avoid;
                            }
                            
                            /* 表格行分页控制 */
                            .print-table tbody tr { 
                                page-break-inside: avoid;
                            }
                            
                            /* 分页设置 */
                            @page {
                                margin: 0.2cm;
                                size: A4 portrait;
                            }
                            
                            /* 第二页及后续页面不显示表头 */
                            @page :not(:first) {
                                @top-center {
                                    content: none;
                                }
                            }
                        }
                    </style>
                </head>
                <body>
                    ${allTablesHTML}
                    
                   
                </body>
                </html>
            `
    },

    // 从 base64 数据下载文件(手机端兼容版)
    downloadFileFromBase64(base64Data, filename) {
      try {
        console.log('📥 开始下载文件:', filename)
        console.log('📱 设备信息:', {
          userAgent: navigator.userAgent,
          isMobile: this.isMobile,
          isIOS: /iPad|iPhone|iPod/.test(navigator.userAgent),
          isAndroid: /Android/.test(navigator.userAgent)
        })

        // 检测文件类型
        let mimeType = 'application/octet-stream'
        let fileExtension = '.csv'

        // 根据 base64 数据头判断文件类型
        if (base64Data.startsWith('data:')) {
          const mimeMatch = base64Data.match(/^data:([^;]+);base64,/)
          if (mimeMatch) {
            mimeType = mimeMatch[1]
            base64Data = base64Data.replace(/^data:[^;]+;base64,/, '')

            if (mimeType.includes('csv')) {
              fileExtension = '.csv'
            } else if (mimeType.includes('excel') || mimeType.includes('spreadsheet')) {
              fileExtension = '.xlsx'
            } else if (mimeType.includes('pdf')) {
              fileExtension = '.pdf'
            }
          }
        }

        // 确保文件名有正确的扩展名
        if (!filename.includes('.')) {
          filename += fileExtension
        }

        console.log('📄 文件信息:', {
          filename: filename,
          mimeType: mimeType,
          base64Length: base64Data.length
        })

        // 根据设备类型选择下载方式
        if (this.isMobile) {
          this.downloadForMobile(base64Data, filename, mimeType)
        } else {
          this.downloadForDesktop(base64Data, filename, mimeType)
        }

      } catch (error) {
        console.error('❌ 文件下载失败:', error)
        ElMessage.error('文件下载失败: ' + error.message)
      }
    },

    // 桌面端下载方法
    downloadForDesktop(base64Data, filename, mimeType) {
      try {
        // 将 base64 转换为 Blob
        const byteCharacters = atob(base64Data)
        const byteNumbers = new Array(byteCharacters.length)

        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i)
        }

        const byteArray = new Uint8Array(byteNumbers)
        const blob = new Blob([byteArray], { type: mimeType })

        // 创建下载链接
        const url = window.URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url
        link.download = filename
        link.style.display = 'none'

        // 触发下载
        document.body.appendChild(link)
        link.click()

        // 清理
        setTimeout(() => {
          document.body.removeChild(link)
          window.URL.revokeObjectURL(url)
        }, 1000)

        console.log('✅ 桌面端文件下载完成:', filename)
        ElMessage.success('文件下载成功!')

      } catch (error) {
        console.error('❌ 桌面端下载失败:', error)
        ElMessage.error('桌面端下载失败: ' + error.message)
      }
    },

    // 手机端下载方法
    downloadForMobile(base64Data, filename, mimeType) {
      try {
        console.log('📱 使用手机端下载方法')
        console.log('🔍 环境检测:', {
          isMobile: this.isMobile,
          isMiniProgram: this.isMiniProgram,
          userAgent: navigator.userAgent
        })

        // 小程序环境优先尝试直接打开,失败后显示复制界面
        if (this.isMiniProgram) {
          console.log('🔗 检测到小程序环境,尝试直接打开')
          // 先尝试直接打开
          if (this.tryDataUrlDownload(base64Data, filename, mimeType)) {
            return
          }
          // 如果直接打开失败,显示复制界面
          console.log('🔗 小程序内直接打开失败,显示复制界面')
          this.showBase64Data(base64Data, filename)
          return
        }

        // 方法1: 尝试使用 Blob 下载
        if (this.tryBlobDownload(base64Data, filename, mimeType)) {
          return
        }

        // 方法2: 使用 data URL 在新窗口打开
        if (this.tryDataUrlDownload(base64Data, filename, mimeType)) {
          return
        }

        // 方法3: 显示 base64 数据让用户手动复制
        this.showBase64Data(base64Data, filename)

      } catch (error) {
        console.error('❌ 手机端下载失败:', error)
        // 降级到显示 base64 数据
        this.showBase64Data(base64Data, filename)
      }
    },

    // 尝试使用 Blob 下载
    tryBlobDownload(base64Data, filename, mimeType) {
      try {
        const byteCharacters = atob(base64Data)
        const byteNumbers = new Array(byteCharacters.length)

        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i)
        }

        const byteArray = new Uint8Array(byteNumbers)
        const blob = new Blob([byteArray], { type: mimeType })

        // 创建下载链接
        const url = window.URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url
        link.download = filename
        link.style.display = 'none'

        // 添加到页面并触发点击
        document.body.appendChild(link)
        link.click()

        // 延迟清理
        setTimeout(() => {
          document.body.removeChild(link)
          window.URL.revokeObjectURL(url)
        }, 1000)

        console.log('✅ 手机端 Blob 下载完成:', filename)
        ElMessage.success('文件下载成功!')
        return true
      } catch (error) {
        console.log('❌ Blob 下载失败:', error)
        return false
      }
    },

    // 尝试使用 data URL 下载
    tryDataUrlDownload(base64Data, filename, mimeType) {
      try {
        const dataUrl = `data:${mimeType};base64,${base64Data}`
        const newWindow = window.open(dataUrl, '_blank')

        if (newWindow) {
          console.log('✅ 手机端 data URL 下载完成:', filename)
          ElMessage.success('文件已在新窗口中打开,请长按保存')
          return true
        } else {
          console.log('❌ 无法打开新窗口')
          return false
        }
      } catch (error) {
        console.log('❌ data URL 下载失败:', error)
        return false
      }
    },

    // 显示 base64 数据供用户手动处理
    showBase64Data(base64Data, filename) {
      // 创建模态框显示 base64 数据
      const modal = document.createElement('div')
      modal.style.cssText = `
                position: fixed;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                background: rgba(0, 0, 0, 0.8);
                z-index: 9999;
                display: flex;
                align-items: center;
                justify-content: center;
                padding: 20px;
                box-sizing: border-box;
            `

      const content = document.createElement('div')
      content.style.cssText = `
                background: white;
                padding: 20px;
                border-radius: 10px;
                max-width: 90%;
                max-height: 80%;
                overflow: auto;
                text-align: center;
            `

      content.innerHTML = `
                <h3 style="margin-bottom: 15px; color: #333;">手机端下载提示</h3>
                <p style="margin-bottom: 15px; color: #666;">由于手机端限制,无法直接下载文件</p>
                <p style="margin-bottom: 15px; color: #666;">请复制以下链接到浏览器中打开:</p>
                <textarea 
                    readonly 
                    style="width: 100%; height: 200px; padding: 10px; border: 1px solid #ddd; border-radius: 5px; font-size: 12px; word-break: break-all;"
                >data:text/csv;base64,${base64Data}</textarea>
                <div style="margin-top: 15px;">
                    <button onclick="const dataUrl = 'data:text/csv;base64,${base64Data}'; const isMiniProgram = /MicroMessenger/i.test(navigator.userAgent) && /miniProgram/i.test(navigator.userAgent); if (isMiniProgram) { navigator.clipboard.writeText(dataUrl).then(() => { alert('已复制到剪贴板,请长按链接选择在浏览器中打开'); }); } else { navigator.clipboard.writeText(dataUrl).then(() => { alert('已复制到剪贴板,正在打开链接...'); window.open(dataUrl, '_blank'); }); }" 
                            style="padding: 10px 20px; background: #409eff; color: white; border: none; border-radius: 5px; margin-right: 10px;">
                        ${this.isMiniProgram ? '复制链接' : '复制并打开链接'}
                    </button>
                    <button onclick="this.parentElement.parentElement.parentElement.remove()" 
                            style="padding: 10px 20px; background: #f56c6c; color: white; border: none; border-radius: 5px;">
                        关闭
                    </button>
                </div>
            `

      modal.appendChild(content)
      document.body.appendChild(modal)

      // 点击背景关闭
      modal.addEventListener('click', (e) => {
        if (e.target === modal) {
          document.body.removeChild(modal)
        }
      })

      ElMessage.info('由于手机端限制,已显示下载提示')
    },

    // 清空文件
    clearFiles() {
      // 清空上传组件的文件列表
      if (this.$refs.uploadRef) {
        this.$refs.uploadRef.clearFiles()
      }

      this.ricelist = []
      this.filetitlelist = []
      this.fileList = []
      this.uploadResult = null
      this.rice = []
      this.findtage123 = []
      this.findtage123copy = []
      this.findtage123all = []
      this.filetitle = ''
      this.tenderid = ''
      this.uploadingInventory = false
      this.batchProcessing = false
    }
  }
}
</script>

<style lang="less" scoped>
.uploadfile {
  padding: 30px;
  max-width: 900px;
  margin: 0 auto;
  background: linear-gradient(135deg, #000000 0%, #764ba2 100%);
  border-radius: 20px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
  position: relative;
  overflow: hidden;
}

.uploadfile::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(45deg, rgba(255, 255, 255, 0.1) 0%, rgba(255, 255, 255, 0.05) 100%);
  pointer-events: none;
}

.device-info {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 20px;
  padding: 10px 15px;
  background: rgba(255, 255, 255, 0.9);
  border-radius: 8px;
  border-left: 4px solid #667eea;
  position: relative;
  z-index: 1;
}

.device-detail {
  font-size: 14px;
  color: #333;
  font-weight: 500;
}

.network-warning {
  margin-bottom: 20px;
  position: relative;
  z-index: 1;
}

.mobile-tips {
  margin-bottom: 20px;
  position: relative;
  z-index: 1;
}

.upload-demo {
  margin-bottom: 25px;
  position: relative;
  z-index: 1;
}

.upload-actions {
  display: flex;
  gap: 15px;
  margin-bottom: 25px;
  flex-wrap: wrap;
  position: relative;
  z-index: 1;
}

.upload-result {
  margin-bottom: 25px;
  position: relative;
  z-index: 1;
}

.data-preview {
  margin-top: 25px;
  position: relative;
  z-index: 1;
}

.preview-tip {
  text-align: center;
  color: rgba(255, 255, 255, 0.8);
  font-size: 14px;
  margin-top: 15px;
  font-weight: 500;
}

:deep(.el-upload-dragger) {
  width: 100%;
  height: 200px;
  background: rgba(255, 255, 255, 0.95);
  border: 3px dashed #667eea;
  border-radius: 15px;
  transition: all 0.3s ease;
  backdrop-filter: blur(10px);
}

:deep(.el-upload-dragger:hover) {
  border-color: #764ba2;
  background: rgba(255, 255, 255, 1);
  transform: translateY(-2px);
  box-shadow: 0 10px 25px rgba(102, 126, 234, 0.3);
}

.upload-trigger {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  padding: 20px;
}

:deep(.el-icon--upload) {
  font-size: 80px;
  color: #667eea;
  margin-bottom: 20px;
  transition: all 0.3s ease;
}

:deep(.el-upload-dragger:hover .el-icon--upload) {
  color: #764ba2;
  transform: scale(1.1);
}

:deep(.el-upload__text) {
  color: #333;
  font-size: 16px;
  text-align: center;
  font-weight: 600;
  line-height: 1.5;

  em {
    color: #667eea;
    font-style: normal;
    font-weight: 700;
    text-decoration: underline;
    text-decoration-color: #764ba2;
  }
}

:deep(.el-upload__tip) {
  color: #fafafa;
  font-size: 13px;
  text-align: center;
  margin-top: 10px;
  font-weight: 500;
}

/* 按钮样式增强 */
:deep(.el-button) {
  border-radius: 25px;
  font-weight: 600;
  padding: 12px 24px;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
}

:deep(.el-button:hover) {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.2);
}

:deep(.el-button--success) {
  background: linear-gradient(45deg, #56ab2f, #a8e6cf);
  border: none;
}

:deep(.el-button--primary) {
  background: linear-gradient(45deg, #667eea, #764ba2);
  border: none;
}

:deep(.el-button--default) {
  background: rgba(255, 255, 255, 0.9);
  color: #333;
  border: 2px solid rgba(255, 255, 255, 0.3);
}

/* 卡片样式增强 */
:deep(.el-card) {
  border-radius: 15px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  border: none;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
}

:deep(.el-card__header) {
  background: linear-gradient(45deg, #667eea, #764ba2);
  color: white;
  font-weight: 600;
  border-radius: 15px 15px 0 0;
  padding: 20px;
}

/* 表格样式增强 */
:deep(.el-table) {
  border-radius: 10px;
  overflow: hidden;
}

:deep(.el-table th) {
  background: linear-gradient(45deg, #f8f9ff, #e8ecff);
  color: #333;
  font-weight: 600;
}

:deep(.el-table tr:hover) {
  background: rgba(102, 126, 234, 0.05);
}

/* 警告框样式增强 */
:deep(.el-alert) {
  border-radius: 10px;
  border: none;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
}

:deep(.el-alert--success) {
  background: linear-gradient(45deg, #d4edda, #c3e6cb);
  color: #155724;
}

:deep(.el-alert--error) {
  background: linear-gradient(45deg, #f8d7da, #f5c6cb);
  color: #721c24;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .uploadfile {
    padding: 20px;
    margin: 10px;
    border-radius: 15px;
  }

  .upload-actions {
    flex-direction: column;
    gap: 10px;
  }

  :deep(.el-button) {
    width: 100%;
  }

  :deep(.el-upload-dragger) {
    height: 160px;
  }

  :deep(.el-icon--upload) {
    font-size: 60px;
  }
}
</style>
